import $ from 'jquery'

document.addEventListener('DOMContentLoaded', function () {
  const words = document.querySelectorAll('.word')

  const getOffset = () => {
    return $('.word').offset().top - $(window).height() / 1.25
  }

  const getWordSpacing = () => {
    return window.innerWidth < 768 ? 25 : 50
  }

  const getThresholds = () => {
    return Array.from(words).map((_, i) => i * getWordSpacing() + getOffset())
  }

  let thresholds = getThresholds()

  const onScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    words.forEach((word, i) => {
      if (scrollTop >= thresholds[i]) word.classList.add('active')
      else word.classList.remove('active')
    })
  }

  window.addEventListener('scroll', onScroll)

  window.addEventListener('resize', () => {
    thresholds = getThresholds()
  })
})
